import { Cars } from '@/core/domain/cars/models/cars.model';
import { GetCarsUseCase } from '@/core/domain/cars/usecases/getCars.usecase';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'fe-cars-cards',
    templateUrl: './cars-cards.component.html',
    styleUrls: ['./cars-cards.component.scss'],
})
export class CarsCardsComponent implements OnInit {
    cars?: Cars;

    constructor(private getCarsUseCase: GetCarsUseCase) {}

    ngOnInit(): void {
        this.getCars();
    }

    public getCars(): void {
        this.getCarsUseCase.execute().subscribe((cars) => {
            this.cars = cars;
        });
    }

    getTopCars(cars: Cars | undefined, count: number) {
        if (!cars) return;
        const allCars = cars.data!.category.flatMap(
            (category) => category.cars,
        );
        return allCars.slice(0, count);
    }
}
